export default "<h1>Type5Boolean list</h1>\n<spec-app-type5-boolean-table [clickHandler]=\"createClickHandler()\"></spec-app-type5-boolean-table>";